import { __decorate } from "tslib";
import { fillTextPositions } from '@twurple/common';
import { Message, MessageParamDefinition, MessageType } from 'ircv3';
import { ChatUser } from "../../../ChatUser.mjs";
import { parseEmoteOffsets, parseEmotePositions } from "../../../utils/emoteUtil.mjs";
/** @private */
let Whisper = class Whisper extends Message {
    get userInfo() {
        return new ChatUser(this._prefix.nick, this._tags);
    }
    get emoteOffsets() {
        return parseEmoteOffsets(this._tags.get('emotes'));
    }
    parseEmotes() {
        const messageText = this.params.message;
        const foundEmotes = parseEmotePositions(messageText, this.emoteOffsets);
        return fillTextPositions(messageText, foundEmotes);
    }
};
__decorate([
    MessageParamDefinition()
], Whisper.prototype, "target", void 0);
__decorate([
    MessageParamDefinition({
        trailing: true,
        optional: true
    })
], Whisper.prototype, "message", void 0);
Whisper = __decorate([
    MessageType('WHISPER')
], Whisper);
export { Whisper };
